<!-- @Description AI4Science-Al+合成生物产品矩阵 -->
<template>
  <van-collapse v-model="activeName" accordion class="productmatrix">
    <van-collapse-item
      title="基于AI的生物制造平台"
      name="1"
      class="productmatrix-item"
      :class="{ 'productmatrix-item-check': activeName == '1' }"
    >
      <div class="info">采用数据层、A引擎层与应用层的分层设计。底层以多源生物数据为基础，包括基因组、代谢通路及调控元件等结构化数据资源;中间层构建以模型驱动的华院认知智能引擎，集成代谢网络建模、酶设计与优化、合成路径预测等核心能力，形成统一的计算与决策平台;上层则面向具体应用场景，覆盖合成生物学设计、菌株优化、生产工艺优化及产业化方案设计，实现从数据到模型再到产业应用的闭环转化，支撑生物制造的高效研发与规模化落地。</div>
      <img
        v-if="productImg1"
        :src="productImg1"
        alt="基于AI的生物制造平台"
        class="productmatrix-img"
      />
      <div class="superiority" v-if="advantageList.swzzpt.length">
        <div class="title">产品价值</div>
        <div
          class="superiority-item"
          v-for="(item, index) in advantageList.swzzpt"
          :key="`productmatrix-item1-superiority${index + 1}`"
        >
          <img :src="product_society_superiority" alt="重要性标志" />
          <span>{{ item }}</span>
        </div>
      </div>
    </van-collapse-item>
    <van-collapse-item
      title="BiosynthEngine"
      name="2"
      class="productmatrix-item"
      :class="{ 'productmatrix-item-check': activeName == '2' }"
    >
      <div class="info">我们通过认知智能引擎平台构建了一个合成生物学引擎-BioSynthEngine.通过基于知识导向的小规模突变库、随机突变位点的饱和突变扫描等构建了一整套完备的酶的筛选流程。</div>
      <img
        v-if="productImg2"
        :src="productImg2"
        alt="BiosynthEngine"
        class="productmatrix-img"
      />
      <div class="superiority" v-if="advantageList.biosynth.length">
        <div class="title">产品价值</div>
        <div
          class="superiority-item"
          v-for="(item, index) in advantageList.biosynth"
          :key="`productmatrix-item2-superiority${index + 1}`"
        >
          <img :src="product_society_superiority" alt="重要性标志" />
          <span>{{ item }}</span>
        </div>
      </div>
    </van-collapse-item>
    <van-collapse-item
      title="大健康食品/食品安全产品研发"
      name="3"
      class="productmatrix-item"
      :class="{ 'productmatrix-item-check': activeName == '3' }"
    >
      <div class="info">我们AI+合成生物的业务主要覆盖应用在大健康食品和食品安全产品。包括但不限于功能食品、食安同源、药食同源、保健食品、新型食品添加剂、食品安全等。</div>
      <img
        v-if="productImg3"
        :src="productImg3"
        alt="大健康食品/食品安全产品研发"
        class="productmatrix-img"
      />
      <div class="superiority" v-if="advantageList.djksp.length">
        <div class="title">产品价值</div>
        <div
          class="superiority-item"
          v-for="(item, index) in advantageList.djksp"
          :key="`productmatrix-item3-superiority${index + 1}`"
        >
          <img :src="product_society_superiority" alt="重要性标志" />
          <span>{{ item }}</span>
        </div>
      </div>
    </van-collapse-item>
  </van-collapse>
</template>
<script>
import product_society_superiority from "@/../static/img/product/product_society_superiority.png";
import aih from "@/../static/img/product/aih.png";
import aih2 from "@/../static/img/product/aih2.png";
import aih3 from "@/../static/img/product/aih3.png";

export default {
  data() {
    return {
      product_society_superiority,
      productImg1: aih,
      productImg2: aih2,
      productImg3: aih3,
      activeName: "",
      advantageList: {
        swzzpt: [],
        biosynth: [],
        djksp: []
      }
    };
  }
};
</script>
<style lang="less" scoped>
.productmatrix {
  width: 100%;
  /deep/.van-cell {
    height: 94px;
    font-size: 28px;
    color: #08204d;
    line-height: 94px;
    text-align: center;
  }
  /deep/ .van-cell__right-icon {
    display: none;
  }
  .productmatrix-item {
    padding: 0 64px;
    background: #ffffff;
    .info {
      font-size: 24px;
      font-family: PingFang-SC-Regular, PingFang-SC;
      font-weight: 400;
      color: #08204d;
      line-height: 40px;
      text-align: justify;
    }
  }
  .productmatrix-item-check {
    /deep/.van-cell__title::before {
      content: "";
      position: absolute;
      bottom: 0px;
      left: 35%;
      width: 30%;
      height: 2px;
      background-color: blue;
    }
  }
  .productmatrix-img {
    width: 100%;
    margin: 44px 0;
  }
  .superiority {
    margin-bottom: 32px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    .title {
      width: 100%;
      height: 36px;
      font-size: 26px;
      color: #08204d;
      line-height: 36px;
      margin-bottom: 24px;
      font-weight: 600;
    }
    .superiority-item {
      display: flex;
      font-size: 24px;
      color: #08204d;
      line-height: 32px;
      margin: 0 50px 32px 0;
      > img {
        width: 32px;
        height: 32px;
        margin-right: 16px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/product/digitization/productmatrix2.vue